import { useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";

// import required modules
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";

const ViolationPointRewardWeb = (props: any) => {
  const user: User = useAppSelector((state) => state.user.user);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (user == undefined)
      navigate("/login", { replace: true });
  }, []);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  return (
    <div className="bg-psp-primary mb-8 font-montserrat">
      {/* <StatsInvoice /> */}
      <div className="h-auto flex bg-psp-primary mt-10">
        <div className="mx-none  container h-full flex-row flex justify-between relative mb-16">
          <div className="flex flex-col rounded-2xl -top-36 relative bg-white items-center py-2 px-8  w-full my-2 mx-1">
            <div className="flex py-2 px-2 w-full relative flex-col bg-white mb-8 ">
              <div className="flex mb-4">
                <BackButton />
                <div className="font-bold text-4xl">
                  {t("VIOLATION.title")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViolationPointRewardWeb;
